import * as React from 'react';
import { createTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import pink from '@material-ui/core/colors/pink';
import { Typography,Link } from '@material-ui/core';

export const theme = createTheme({
  palette: {
    type: 'dark',
    primary: pink,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
  typography: {
    fontSize: 12
  },
  spacing: 6,
  props: {
    MuiListItem: {
      dense: true,
    },
  },
  overrides: {
    RaList: {
      root: {
        marginTop: '30px'
      }
    }
  }
});

export const useFormStyles = makeStyles(() => ({
  paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
  },
  avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
  },
  form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
  },
  submit: {
      margin: theme.spacing(3, 0, 2),
  }
}));

export function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://nobid.io/">
        NoBid, Inc.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}